import React from "react";
import Image from "../../components/Image/Image";
import IconComponent from "../../components/Icon/IconComponent";
import { ICON_LABELS } from "../../utils/constants/UI/iconLabels";
import { AUTH_ASIDE_LOGO } from "../../utils/constants/assets";
import { BASE } from "../../utils/constants/colors";

const ASIDE_STATS = [
  {
    icon: ICON_LABELS.MANAGE_SEARCH,
    title: "AI ICP Scoring",
    description: "Pinpoint your best-fit buyers",
  },
  {
    icon: ICON_LABELS.CAMPAIGN,
    title: "3-Channel Sequences",
    description: "Email, calls & LinkedIn",
  },
  {
    icon: ICON_LABELS.TRENDING_UP,
    title: "Full Pipeline View",
    description: "From outreach to closed deal",
  },
];

const AuthAside = ({ classes }) => (
  <aside className={classes.authAside}>
    <div className={classes.asideLogoRow}>
      <Image src={AUTH_ASIDE_LOGO} className={classes.asideLogo} alt="ReachIQ" />
    </div>
    <div className={classes.asideTextBlock}>
      <p className={classes.asideHeading}>
        Qualified meetings,
        <br />
        not more leads.
      </p>
      <p className={classes.asideSubText}>
        ReachIQ is the outbound platform built for B2B sales teams. Identify
        high-fit prospects, run multi-channel sequences, and turn replies into revenue.
      </p>
    </div>
    <div className={classes.asideStats}>
      {ASIDE_STATS.map((stat) => (
        <div className={classes.asideStatRow} key={stat.title}>
          <span className={classes.asideStatIcon}>
            <IconComponent iconLabel={stat.icon} fontSize="20px" color={BASE.WHITE} />
          </span>
          <div className={classes.asideStatText}>
            <strong className={classes.asideStatBold}>{stat.title}</strong>
            <small className={classes.asideStatSmall}>{stat.description}</small>
          </div>
        </div>
      ))}
    </div>
  </aside>
);

export default AuthAside;
